import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { SectionLecture } from "../../../../models/course-content.model";

@Component({
  selector: "ngx-preview-lectures",
  styleUrls: ["./lectures.component.scss"],
  templateUrl: "./lectures.component.html",
})
export class PreviewCourseSectionLecturesComponent implements OnInit {
  @ViewChild("item", { static: true }) accordion;

  @Output() onOpenSourceContent: EventEmitter<any> = new EventEmitter();
  @Output() onEnrollCourse: EventEmitter<any> = new EventEmitter();

  @Input() courseId = "";
  @Input() sectionId = "";
  @Input() lectureContentId = "";
  @Input() sourceType = "";
  @Input() lectures?: SectionLecture[];

  loading = false;
  lectureId = "";

  constructor() {}

  ngOnInit() {}

  //Open source content view
  openSourceContent(item: SectionLecture) {
    if (item.status == 1 && !item.privacy && item.sourceType !== "") {
      this.sourceType = item.sourceType;
      this.lectureContentId = item.lectureContentId;
      this.onOpenSourceContent.emit(item);
    } else {
      this.onEnrollCourse.emit(item);
    }
  }
}
